require('../bootstrap');
require('jquery.easing');

/* Vue is not required in front
window.Vue = require('vue').default;

const app = new Vue({
    el: '#app',
});
*/

(function($) {
  "use strict"; // Start of use strict

  $("html").attr('class', 'js'); // change class no-js to js to detect javascript support
  
  // Smooth scrolling using jQuery easing
  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top - 48)
        }, 1000, "easeInOutExpo");
        return false;
      }
    }
  });

  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(function() {
    $('.navbar-collapse').collapse('hide');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: '#navbarResponsive',
    offset: 54
  });

  // Collapse the navbar when page is scrolled
  $(window).scroll(function() {
    if ($("#mainNav").offset().top > 100) {
      $("#mainNav").addClass("navbar-shrink");
	 
    } else {
      $("#mainNav").removeClass("navbar-shrink");
     
    }
  });

  // Search UI
  var mainContainer = $('.main-wrap'),
  	openCtrl = $('.btn-search-open'),
  	closeCtrl = $('#btn-search-close'),
  	searchContainer = $('#search'),
  	inputSearch = $('#search .search-query');

  function initSearchEvents() {
  	closeCtrl.on('click', closeSearch);
  	openCtrl.on('click', function(e) {
  		e.preventDefault();
  		openSearch();
  	});
  	$(document).on('keyup', function(e) {
  		// escape key.
  		if( e.keyCode == 27 ) {
  			closeSearch();
  		}
  	});
  }
  
  function openSearch() {
  	mainContainer.addClass('main-wrap-hide');
  	searchContainer.addClass('search-open');
  	setTimeout(function() {
  		inputSearch.focus();
  	}, 500);
  }
  
  function closeSearch() {
  	mainContainer.removeClass('main-wrap-hide');
  	searchContainer.removeClass('search-open');
  	inputSearch.blur();
  	inputSearch.value = '';
  }
  
  // Inits  
  initSearchEvents();
  parallaxIt();
  initMap();
  pagePopin();
  pagePopinHome();
  modalCloseVidNcs();
  
})(jQuery); // End of use strict
  
// Map
var map = null;
function initMap() {
	map = L.map('map').setView([48.8343129, 2.3680589], 15);
	// L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
	// L.tileLayer('https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
	L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &amp; <a href="https://carto.com/attributions">CARTO</a>',
		minZoom: 1,
		maxZoom: 20
	}).addTo(map);
	
	map.on('map-container-resize', function () {
		setTimeout(function(){ 
			map.invalidateSize();
			map.panTo(new L.LatLng(48.8343129, 2.3680589));
		}, 400);
	});
	var markerIcon = L.icon({
		iconUrl: assetBaseUrl + 'images/picto-map.svg',
	});	
	var marker = L.marker([48.8343129, 2.3680589], { icon: markerIcon }).addTo(map);
}

// Parallax
function parallaxIt() {

  // create variables
  var $fwindow = $(window);
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // on window scroll event
  $fwindow.on('scroll resize', function() {
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  }); 

  // for each of content parallax element
  $('[data-type="content"]').each(function (index, e) {
    var $contentObj = $(this);
    var fgOffset = parseInt($contentObj.offset().top);
    var yPos;
    var speed = ($contentObj.data('speed') || 1 );

    $fwindow.on('scroll resize', function (){
      yPos = fgOffset - scrollTop / speed; 

      $contentObj.css('top', yPos);
    });
  });

  // for each of background parallax element
  $('[data-type="background"]').each(function(){
    var $backgroundObj = $(this);
    var bgOffset = parseInt($backgroundObj.offset().top);
    var yPos;
    var coords;
    var speed = ($backgroundObj.data('speed') || 0 );

    $fwindow.on('scroll resize', function() {
      yPos = - ((scrollTop - bgOffset) / speed); 
      coords = '40% '+ yPos + 'px';

      $backgroundObj.css({ backgroundPosition: coords });
    }); 
  }); 

  // triggers winodw scroll for refresh
  $fwindow.trigger('scroll');
};
function pagePopinHome() {
  var nbPop=2;
  var popToOpen = Math.floor(Math.random() * nbPop);
  popToOpen="#modalhome-"+popToOpen;  
  $(popToOpen).modal('show')
};
function modalCloseVidNcs() {
  $('#modalhome-nc').on('hidden.bs.modal', function (e) {
    var vid = document.getElementById('videoNCS');
    console.log("video ncs paused");
    vid.pause();
    vid.currentTime = 0;
  })
};

function pagePopin() {
  
  $('#modalofpage').modal('show')
};
